module.exports = __webpack_public_path__ + "static/media/case4.be9999bc.png";